import React from "react";
import { useTranslation } from "react-i18next";
import { URL_BARCODE } from "../../constance/urls";
import FactoryWoodExportDetailModal from "./FactoryWoodExportDetailModal";
import { defaultFactoryWoodExportTransactionDetail } from "../../constance/dataTypes";
import TSTable from "../common/TSTable";
import { Form, Select, Space, Input, DatePicker } from "antd";
import {
  PlusOutlined,
  CheckOutlined,
  CloseOutlined,
  PrinterFilled,
  FileTextFilled,
} from "@ant-design/icons";
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from "../../constance/strings";
import { BLUE_COLOR, GREEN } from "../../constance/color";
import { useDebounce } from "use-debounce";
import dayjs from "dayjs";
import ColorButton from "../common/ColorButton";
export default function FactoryWoodExportList() {
  const { t } = useTranslation();
  const [tableKey, setTableKey] = React.useState(0);
  const tableRef = React.useRef();
  const [form] = Form.useForm();
  const status = Form.useWatch("status", form);
  const date = Form.useWatch("produce_date", form);
  const searchText = Form.useWatch("search", form);
  const [debouncedText] = useDebounce(searchText, 500);
  const [hasSearched, setHasSearched] = React.useState(false);

  const [isDetailModalOpen, setIsDetailModalOpen] = React.useState(false);
  const [selected, setSelected] = React.useState(
    defaultFactoryWoodExportTransactionDetail
  );

  const columns = React.useMemo(
    () => [
      {
        title: t("date"),
        dataIndex: "created",
        render: (__, original) =>
          new Date(original.created).toLocaleString("en-GB"),
      },
      {
        title: t("factory_wood_exports.order_no"),
        dataIndex: "order_no",
      },
      {
        title: t("factory_wood_exports.destination_factory"),
        dataIndex: "destination_factory",
      },
      {
        title: t("trucks.license_plate"),
        dataIndex: "license_plate",
      },
      {
        title: t("factory_wood_exports.is_exported"),
        dataIndex: "is_exported",
        render: (text, row) => (
          <div style={{ textAlign: "center" }}>
            {row.is_exported ? (
              <CheckOutlined style={{ color: "green" }} />
            ) : (
              <CloseOutlined style={{ color: "red" }} />
            )}
          </div>
        ),
      },
      {
        title: () => null,
        dataIndex: "id",
        render: (__, original) => (
          <Space style={{ display: "flex", justifyContent: "center" }}>
            <ColorButton
              variant="outlined"
              color="primary"
              override={
                original.truck_transactions.length > 0 ? BLUE_COLOR : GREEN
              }
              icon={
                original.truck_transactions.length > 0 ? (
                  <FileTextFilled />
                ) : (
                  <PlusOutlined />
                )
              }
              onClick={() => {
                setIsDetailModalOpen(true);
                setSelected(original.id);
              }}
            >
              {original.truck_transactions.length > 0
                ? t("detail")
                : `${t("select")} ${t("trucks.license_plate")}`}
            </ColorButton>
            {original.truck_transactions.length > 0 && (
              <ColorButton
                variant="outlined"
                color="primary"
                override={BLUE_COLOR}
                icon={<PrinterFilled />}
                primary
                onClick={() =>
                  window.open(
                    `${URL_BARCODE.WOOD_EXPORT_TRANSACTION_EXPORT}${original.id}`
                  )
                }
              >
                {t("factory_wood_exports.print")}
              </ColorButton>
            )}
          </Space>
        ),
      },
    ],
    [date]
  );
  const handleCloseModal = () => {
    setIsDetailModalOpen(false);
    setTableKey((prevKey) => prevKey + 1);
  };

  React.useEffect(() => {
    if (!hasSearched) {
      setHasSearched(true);
      return;
    } else tableRef.current.fetch();
  }, [status, date, debouncedText]);

  return (
    <div>
      <Form form={form}>
        <Space style={{ float: "left" }}>
          <Form.Item label={t("status")} name={"status"}>
            <Select defaultValue={"ALL"} style={{ width: 200 }}>
              <Select.Option value="ALL">
                {t("factory_wood_exports.status.all")}
              </Select.Option>
              <Select.Option value="UNFINISHED">
                {t("factory_wood_exports.status.unfinished")}
              </Select.Option>
              <Select.Option value="FINISHED">
                {t("factory_wood_exports.status.finished")}
              </Select.Option>
              <Select.Option value="EXPORTED">
                {t("factory_wood_exports.status.exported")}
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label={t("searchs.fields.date")} name={"produce_date"}>
            <DatePicker
              format={HUMAN_DATE_FORMAT}
              placeholder={t("searchs.placeholders.date")}
              style={{ width: 200 }}
            />
          </Form.Item>
          <Form.Item label={t("search")} name={"search"}>
            <Input placeholder={t("search")} allowClear />
          </Form.Item>
        </Space>
      </Form>

      <FactoryWoodExportDetailModal
        open={isDetailModalOpen}
        onClose={handleCloseModal}
        detail={selected}
      />
      <TSTable
        scroll={{ x: 1000 }}
        ref={tableRef}
        key={tableKey}
        url={URL_BARCODE.WOOD_EXPORT_TRANSACTION}
        columns={columns}
        params={{
          date: date ? dayjs(date).format(DATE_FORMAT) : null,
          status: status,
          search: searchText || null,
        }}
      />
    </div>
  );
}
